import React from "react";

import activitiesService from "presentation/services/activities";
import activitiesQuestionsService from "presentation/services/activity-questions";
import activitiesAnswersService from "presentation/services/activity-answers";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import ActivityFillForm from 'presentation/pages/activities/elements/fill-form';
import { mountAnswers } from 'presentation/pages/activities/functions/activities';

class ActivityFill extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      form: {},
      actionLoading: false,
      error: false,
      message: '',
      activity: [],
      questions: [],
      answers: [],
    };

    this.loadData = this.loadData.bind(this);

  }

  async componentDidMount() {
    const { state } = this.props.location;
    const { activityId, studentId } = state || [];

    if (activityId && studentId) {
      await this.loadData(activityId, studentId);
    } else {
      this.setState({ error: true, loading: false, message: "Não foi possível identificar a atividade/aluno" });
    }

  }

  loadData = async (id, rawStudentId) => {
    var activityId = parseInt(id);
    var studentId = parseInt(rawStudentId);
    var actityResults = await activitiesService.findById(activityId);
    var actityQuestionsResults = await activitiesQuestionsService.search({ activityId: [activityId] });
    var activityAnswerResults = await activitiesAnswersService.search({ activityId: [activityId], studentId: [studentId] });

    await Promise.all([actityResults, actityQuestionsResults, activityAnswerResults]);

    var answers = mountAnswers(activityAnswerResults);

     //Sort by order defined in activity 
      // const loadedQuestions = actityQuestionsResults.sort((a, b) => a.order - b.order);
      
      //Randomize question for end user
      const loadedQuestions = actityQuestionsResults.sort(() => Math.random() - Math.random());

    this.setState({ activity: actityResults, questions: loadedQuestions, answers: answers, loading: false });
  }

  render() {
    const { location } = this.props;
    const { state } = location;
    const { activityId, studentId } = state || [];
    let { loading, error, message, actionLoading } = this.state;
    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && error == false && (
          <ActivityFillForm
            component={this}
            activityId={activityId}
            studentId={studentId}
          />
        )
        }
      </div>
    );
  };
}

export default ActivityFill;
